/**
 * CSV共通ユーティリティ。
 * Excel互換のため BOM 付き UTF-8 で出力する。
 * サーバー側（api/src/libs/utils/csv.ts）と同じエスケープ・改行方針に揃える。
 */

/** セルをダブルクォートでエスケープ（`"` は `""` に置換し、カンマ・改行を含む値も安全に囲む）。 */
export const escapeCsvCell = (value: unknown): string => {
  const s = value === null || value === undefined ? '' : String(value);
  return `"${s.replace(/"/g, '""')}"`;
};

/** カラム定義（表示名 + データキー）と行データから CSV 文字列を生成する。 */
export const buildCsv = <T extends Record<string, unknown>>(
  columns: { displayName: string; id: string }[],
  rows: T[],
): string => {
  const header = columns.map((c) => escapeCsvCell(c.displayName)).join(',');
  const body = rows.map((row) =>
    columns.map((c) => escapeCsvCell(row[c.id])).join(','),
  );
  return [header, ...body].join('\r\n');
};

/** BOM 付き UTF-8 の CSV をブラウザでダウンロードさせる。 */
export const downloadCsv = (csv: string, filename: string): void => {
  const bom = '﻿';
  const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
